export default __webpack_public_path__ + "static/media/ic_arrow_down.ba9d0895.svg";